import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/legacy-dialog";
import { TranslationService } from '@sdbn/common';
import { TransportCreationProfileGroup } from 'src/tmc-yard/client/model/station-usage.model';

@Component({
  selector: 'add-transport-creation-profile-group-dialog.component',
  templateUrl: './add-transport-creation-profile-group-dialog.component.html',
  styleUrls: ['./add-transport-creation-profile-group-dialog.component.scss']
})
export class AddTransportCreationProfileGroupDialogComponent implements OnInit {

    profileGroup = new FormGroup({
        groupName: new FormControl<string>('', Validators.required)
    });

  constructor(
    public translationService: TranslationService,
    public dialogRef: MatDialogRef<AddTransportCreationProfileGroupDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TransportCreationProfileGroup
  ) {

  }

  ngOnInit(): void {
  }

  onClose() {
    this.dialogRef.close(null);
  }

  onConfirm() {
    this.dialogRef.close(new TransportCreationProfileGroup({displayName: this.profileGroup.controls.groupName.value ?? ''}));
  }

  confirmDisabled(): boolean {
    return !this.profileGroup.valid;
  }


}
